import { render, staticRenderFns } from "./OutboundOrderSend.vue?vue&type=template&id=1fff230c&scoped=true&"
import script from "./OutboundOrderSend.vue?vue&type=script&lang=js&"
export * from "./OutboundOrderSend.vue?vue&type=script&lang=js&"
import style0 from "./OutboundOrderSend.vue?vue&type=style&index=0&id=1fff230c&scoped=true&lang=less&"
import style1 from "./OutboundOrderSend.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff230c",
  null
  
)

export default component.exports